interface Config {
  API_URL: string;
  isElectron: boolean;
}

/**
 * Detects if the application is running in an Electron environment.
 */
const detectElectron = (): boolean => {
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process?.type === 'renderer') {
    return true;
  }
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true;
  }
  return false;
};

const isElectron = detectElectron();

// Determine if DNS resolution is enabled
const DNS_ENABLED = process.env.DNS_ENABLED === 'true';

// Use environment variables for API_HOST and API_HOST_PORT, or fallback to hardcoded values
const INTERNAL_API_URL = DNS_ENABLED
  ? `http://${process.env.API_HOST ?? 'srv-captain--kasaka-api'}:${process.env.API_HOST_PORT ?? '4000'}`
  : 'http://srv-captain--kasaka-api:4000'; // Hardcoded fallback

const EXTERNAL_API_URL = 'https://api-prd.kasaka.co.zm';
const API_VERSION = 'v1';

// Final configuration object
const config: Config = {
  isElectron,
  API_URL: DNS_ENABLED
    ? `${INTERNAL_API_URL}/api/${API_VERSION}` // Use internal URL if DNS_ENABLED is true
    : `${EXTERNAL_API_URL}/api/${API_VERSION}`, // Otherwise, use external URL
};

export default Object.freeze(config);
